import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import "../../../Styles/style.css";
import AdminApiModule from "../../../components/AdminApi/Api/api";
import { useNavigate, useLocation } from "react-router-dom";
import { Alert, InputAdornment, Snackbar, Typography } from "@mui/material";
import { useSelector } from "react-redux";

// Fixed styled component - use theme from props or provide default
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme?.palette?.mode === "dark" ? "#1A2027" : "#fff",
  ...theme?.typography?.body2,
  padding: theme?.spacing(1) || 8,
  textAlign: "center",
  color: theme?.palette?.text?.secondary,
}));

const stylesCss = {
  inputBox: {
    width: "100%",
    marginBottom: "10px",
  },
  gridStyle: {
    width: "80%",
    margin: "auto",
  },
  paddingInnerGrids: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "10px",
  },
};

const AddCenterOnboarder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const reduxState = useSelector((state) => state.userReducer);

  const [formData, setFormData] = useState({
    name: "",
    countryCode: "+91",
    mobileNumber: "",
    uniqueId: "",
  });

  const [toast, setToast] = useState({
    open: false,
    msg: "",
    duration: 5000,
    type: "",
  });

  const [state, setState] = useState({
    isFormValid: false,
    isRegistering: false,
    isEditDetailsExists: false,
    doesCenterOnboarderExists: false,
    isOtpSentSuccess: false,
  });

  useEffect(() => {
    console.log("hey man", reduxState);

    let searchParams = new URLSearchParams(location.search);
    let editCenterOnboarderId = searchParams.get("edit");

    console.log(editCenterOnboarderId, "edit center onboarder id");

    if (editCenterOnboarderId != null) {
      getCenterOnboarderDetails(editCenterOnboarderId);
    }
  }, [location.search, reduxState]);

  const getCenterOnboarderObjIdForEdit = () => {
    return new URLSearchParams(location.search).get("edit");
  };

  const getCenterOnboarderDetails = (editCenterOnboarderId) => {
    let payload = {
      center_onboarder_id: editCenterOnboarderId,
    };

    setState((prev) => ({
      ...prev,
      isEditDetailsExists: true,
    }));

    new AdminApiModule()
      .getAllCenterOnBoarder(payload)
      .then((res) => {
        if (res?.data?.length) {
          setState((prev) => ({
            ...prev,
            doesCenterOnboarderExists: true,
          }));

          updateCenterOnboarderDetails(res?.data?.[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateCenterOnboarderDetails = (centerOnboarderDetails) => {
    setFormData({
      name: centerOnboarderDetails?.name || "",
      countryCode: "+91",
      mobileNumber: centerOnboarderDetails?.phone_details?.mobile_number || "",
      uniqueId: centerOnboarderDetails?.uniqueId || "",
    });
  };

  const showDialog = (open, type, msg) => {
    setToast({
      open: open,
      msg: msg,
      duration: 5000,
      type: type,
    });
  };

  const closeDialog = (open = false) => {
    setToast({
      open: open,
      msg: "",
      duration: 5000,
      type: "",
    });
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRegister = () => {
    if (!(formData.name && formData.mobileNumber)) {
      setState((prev) => ({
        ...prev,
        isFormValid: true,
      }));

      showDialog(true, "error", "Please fill in all required details");
      return;
    }

    setState((prev) => ({
      ...prev,
      isRegistering: true,
    }));

    let payload = {
      name: formData.name,
      phone_details: {
        country_code: "+91",
        mobile_number: formData.mobileNumber,
      },
    };

    if (state.isEditDetailsExists) {
      payload.center_onboarder_id = getCenterOnboarderObjIdForEdit();

      payload["name"] = formData.name || "";

      if (formData.mobileNumber) {
        payload["phone_details"] = {
          country_code: "+91",
          mobile_number: formData.mobileNumber,
        };
      }

      new AdminApiModule()
        .adminUpdateCenterOnBoarder(payload)
        .then((res) => {
          showDialog(true, "success", "Center Onboarder updated successfully");

          setState((prev) => ({
            ...prev,
            isRegistering: false,
          }));

          navigate("/admin-center-onboarders");
        })
        .catch((err) => {
          console.log(err);
          showDialog(true, "error", err?.response?.data?.message);
          setState((prev) => ({
            ...prev,
            isRegistering: false,
          }));
        });

      return;
    }

    new AdminApiModule()
      .adminCreateCenterOnBoarder(payload)
      .then((res) => {
        showDialog(true, "success", "Center Onboarder Created successfully");

        handleResetValues();
        navigate("/admin-center-onboarders");
      })
      .catch((err) => {
        console.log(err);
        setState((prev) => ({
          ...prev,
          isRegistering: false,
        }));
        showDialog(true, "error", err?.response?.data?.message);
      });
  };

  const handleResetValues = () => {
    setState((prev) => ({
      ...prev,
      isRegistering: false,
    }));

    setFormData({
      name: "",
      countryCode: "+91",
      mobileNumber: "",
      uniqueId: "",
    });
  };

  const {
    isFormValid,
    isRegistering,
    isEditDetailsExists,
    doesCenterOnboarderExists,
    isOtpSentSuccess,
  } = state;
  const { name, mobileNumber } = formData;

  if (isEditDetailsExists && !doesCenterOnboarderExists) {
    return <>Page not found !!!</>;
  }

  return (
    <div>
      {toast.open && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={toast.open}
          autoHideDuration={toast.duration}
          onClose={closeDialog}
        >
          <Alert
            onClose={closeDialog}
            severity={toast.type}
            sx={{ width: "100%" }}
          >
            {toast.msg}
          </Alert>
        </Snackbar>
      )}
      <h2 className="text-align-center">
        {isEditDetailsExists
          ? "Update Center Onboarder"
          : "Add Center Onboarder"}
      </h2>
      <Item>
        <Grid container>
          <Grid item style={stylesCss.paddingInnerGrids} md={6}>
            <TextField
              helperText="Please provide your Shop / Center (Name)"
              id="demo-helper-text-misaligned"
              label="Shop / Center (Name)"
              name="name"
              onChange={handleChange}
              style={stylesCss.inputBox}
              error={isFormValid && !name}
              value={name}
            />
          </Grid>

          <Grid item style={stylesCss.paddingInnerGrids} md={6}>
            <TextField
              helperText="Please provide your mobile number"
              id="demo-helper-text-misaligned"
              label="Mobile Number"
              name="mobileNumber"
              disabled={isOtpSentSuccess}
              onChange={handleChange}
              style={stylesCss.inputBox}
              error={isFormValid && !mobileNumber}
              value={mobileNumber}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography>+91</Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>

          <Grid style={stylesCss.paddingInnerGrids} item md={6}>
            <Button
              variant="contained"
              onClick={handleRegister}
              disabled={isRegistering}
            >
              {isEditDetailsExists ? "Update " : "Save"}
            </Button>
          </Grid>
        </Grid>
      </Item>
    </div>
  );
};

export default AddCenterOnboarder;
